import React, { useEffect, useState } from 'react';
import { getData, } from '../../services/apiService';
import { useSearchParams } from 'react-router-dom';
import Layout from '../../components/layout/Layout';

const QuizResults = () => {
    const [searchParams] = useSearchParams();
    const submissionId = searchParams.get('submissionId');
    const [quizResult, setQuizResult] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchQuizResult = async () => {
            try {
                const response = await getData(`/quiz-results/${submissionId}`);
                setQuizResult(response);
                setLoading(false);
            } catch (err) {
                setError(err.response?.data?.message || 'Failed to fetch quiz results');
                setLoading(false);
            }
        };

        fetchQuizResult();
    }, [submissionId]);

    // if (loading) return <Layout><div>Loading...</div></Layout>;
    if (error) return <Layout><div className="error">{error}</div></Layout>;
    if (!quizResult) return <Layout><div>No quiz results found</div></Layout>;

    return (
        <Layout>
            <div className="p-6 bg-gray-100 min-h-screen">
                <div className="quiz-results-container">
                    <h1>Quiz Results: {quizResult.quiz.title}</h1>
                    <p className="quiz-description">{quizResult.quiz.instructions}</p>

                    <div className="user-info">
                        <h2>User: {quizResult.user.firstName} {quizResult.user.lastName}</h2>
                        <p>Email: {quizResult.user.email}</p>
                    </div>

                    <div className="score-summary">
                        <h2>Score: {quizResult.score} %</h2>
                        {/* <h2>Score: {quizResult.score} / {quizResult.totalQuestions} ( {Math.round((quizResult.score / quizResult.totalQuestions) * 100)}%)</h2> */}
                        <p>Submitted on: {new Date(quizResult.submittedAt).toLocaleString()}</p>
                    </div>

                    <div className="questions-results">
                        <h2>Detailed Results:</h2>
                        {quizResult.detailedAnswers.map((answer, index) => (
                            <div key={answer.questionId} className={`question-result ${answer.isCorrect ? 'correct' : 'incorrect'}`} >
                                <h3>Question {index + 1}: {answer.questionText}</h3>

                                <div className="options-container">
                                    <div className="correct-options">
                                        <h4>Correct Answer(s):</h4>
                                        {answer.correctOptions.length > 0 ? (
                                            <ul>
                                                {answer.correctOptions.map((option, i) => (
                                                    <li key={i}>{option}</li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p>No correct options provided</p>
                                        )}
                                    </div>

                                    <div className="user-options">
                                        <h4>Your Answer(s):</h4>
                                        {answer.selectedOptions.length > 0 ? (
                                            <ul>
                                                {answer.selectedOptions.map((option, i) => (
                                                    <li key={i}>{option}</li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p>No answer selected</p>
                                        )}
                                    </div>
                                </div>

                                <div className="answer-status">
                                    {answer.isCorrect ? (
                                        <span className="correct-badge">✓ Correct</span>
                                    ) : (
                                        <span className="incorrect-badge">✗ Incorrect</span>
                                    )}
                                </div>

                                {answer.explanation && (
                                    <div className="explanation">
                                        <h4>Explanation:</h4>
                                        <p>{answer.explanation}</p>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default QuizResults;
